import {
  createApi,
  fetchBaseQuery,
  FetchBaseQueryError,
  retry,
} from '@reduxjs/toolkit/query/react';
import { RootState } from '../../../../app/store';
import config from '../../../../config';

const WRANGLER_URL = config.api.wranglerUrl;
export const wranglerSlice = createApi({
  reducerPath: 'wrangler',
  baseQuery: retry(
    fetchBaseQuery({
      baseUrl: WRANGLER_URL,
      mode: 'cors',
      prepareHeaders: async (headers, { getState }) => {
        const access_token = (getState() as RootState).auth.apiToken;
        if (access_token) {
          headers.set('Authorization', `Bearer ${access_token}`);
        }
        return headers;
      },
    }),
    {
      retryCondition: (error: FetchBaseQueryError, _, { attempt }) => {
        if (attempt > 3) {
          return false;
        }

        if (typeof error.status === 'number') {
          if (error.status > 499 && error.status < 600) {
            return true;
          }
        }

        if (
          error.status === 'TIMEOUT_ERROR' ||
          error.status === 'FETCH_ERROR'
        ) {
          return true;
        }

        return false;
      },
    }
  ),
  tagTypes: ['PointDetection'],
  endpoints: () => ({}), // All endpoints will be injected in other files
});
